// extracted by mini-css-extract-plugin
export var menuIcon = "_ob-0";
export var menuIconInline = "_ob-1";